/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_No_Need_ReminderInputs */

const en_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Need`)
};

const ar_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا حاجة`)
};

const de_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade nicht`)
};

const es_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No es necesario`)
};

const fr_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas besoin`)
};

const it_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non c'è bisogno`)
};

const ja_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ、不要です`)
};

const ko_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`거절`)
};

const pt_br_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não é preciso`)
};

const ru_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не нужно`)
};

const th_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ต้องการ`)
};

const tr_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerek Yok`)
};

const zh_cn_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不用提醒`)
};

const zh_tw_btn_no_need_reminder = /** @type {(inputs: Btn_No_Need_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不用提醒`)
};

/**
* | output |
* | --- |
* | "No Need" |
*
* @param {Btn_No_Need_ReminderInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_no_need_reminder = /** @type {((inputs?: Btn_No_Need_ReminderInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_No_Need_ReminderInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_no_need_reminder(inputs)
	if (locale === "ar") return ar_btn_no_need_reminder(inputs)
	if (locale === "de") return de_btn_no_need_reminder(inputs)
	if (locale === "es") return es_btn_no_need_reminder(inputs)
	if (locale === "fr") return fr_btn_no_need_reminder(inputs)
	if (locale === "it") return it_btn_no_need_reminder(inputs)
	if (locale === "ja") return ja_btn_no_need_reminder(inputs)
	if (locale === "ko") return ko_btn_no_need_reminder(inputs)
	if (locale === "pt_br") return pt_br_btn_no_need_reminder(inputs)
	if (locale === "ru") return ru_btn_no_need_reminder(inputs)
	if (locale === "th") return th_btn_no_need_reminder(inputs)
	if (locale === "tr") return tr_btn_no_need_reminder(inputs)
	if (locale === "zh_cn") return zh_cn_btn_no_need_reminder(inputs)
	return zh_tw_btn_no_need_reminder(inputs)
});